
import './App.css';
import React, { useRef,useState,useEffect  } from 'react';
import { useLocation } from "react";
import ChatMessage from './ChatMessage';
import ChatMessageHistroy from './ChatMessageHistroy';
import ChatInput from './ChatInput';
import ChatMessageWelcome from './ChatWelcome';
import TopMessageControl from './TopMessage';
import { API_URL } from './config';
import Fingerprint2 from 'fingerprintjs2';
import CallAndEmail from './CallAndEmail';

const ChatUI = () => {
  const [fingerprintOwn, setFingerprint] = useState("");
  
  const [messages, setMessages] = useState([]);
  const [messagesHistroy, setMessagesHistroy] = useState([]);
  const [loadingText, setLoadingText] = useState('Generating, please wait');
  const [isGenerating, setGenerating]= useState(false);
  const chatHistoryRef = useRef(null);
  const chatMainRef = useRef(null);
  const dotsIntervalRef = useRef(null);
  const sendMessageRef = useRef(null);

 
  
    const handleSendMessage = (message, bUser, bError = false, answer) => {
      setMessages(prevMessages => [...prevMessages, { text: message, isUser: bUser, isError: bError, answer: answer }]);
      setGenerating(bUser)
    };


    const onButtonClick = (value) =>{
      console.log("onButtonClick: " + value)
      const queryParams = new URLSearchParams(window.location.search);
      const param = queryParams.get("param");
      const productType = queryParams.get("productType");
      
      if(sendMessageRef.current){
        sendMessageRef.current.ParentHandleSendMessage(value, productType);
      }
    }

    function callbackGetList (json) {
      try {
        let jsonObject = window.JSON.parse(json);
        console.log(jsonObject)
        if(jsonObject.code === 200){
           // 提取所有的 question 和 updatedAt 字段
          let extractedData = jsonObject.data.map(item => ({
            question: item.question,
            answer: item.answer,
            createdAt: item.createdat
          }));
          if(extractedData === undefined || extractedData === null){
            setMessagesHistroy([]);
            console.log('No data');
          }
          else{
            setMessagesHistroy(extractedData);
          }
        }
      } catch (error) {
        // 如果上面的操作抛出异常，这里的代码将会执行
        console.error('Error during data fetching:', error);
      }
    };

    const getHistoryList = async ( callback, fingerprintTmp) =>
      {
        let httpRequest = new XMLHttpRequest();
        httpRequest.open('GET', `${API_URL}/chat/getListByPage?page=1&count=10&userId=${fingerprintTmp}`, true);
        httpRequest.send();
    
        httpRequest.onreadystatechange = function () {//
          if (httpRequest.readyState === 4 && httpRequest.status === 200) {
            let json = httpRequest.responseText;
            callback(json);
          }else{
            console.error(`Request failed with status: ${httpRequest.status}, response: ${httpRequest.responseText}`);
          }
        };
      }

  function getFingerprint2 () {
    // 使用 fingerprintjs2 获取设备标识符
    const figTemp = Fingerprint2.get(function (components) {
      const fingerprintTmp = Fingerprint2.x64hash128(components.map(pair => pair.value).join(), 31);
      
      setFingerprint(figTemp)
      console.log('fingerprint: ' + fingerprintTmp);
      getHistoryList(callbackGetList, fingerprintTmp);
      return fingerprintTmp
      // 在这里可以将设备标识符发送到服务器，或者存储在本地
    });
    
  }

  
  // 在组件挂载后和 messages 更新后滚动到底部
  useEffect(() => {
    dotsIntervalRef.current = setInterval(() => {
      setLoadingText((prevText) => {
        // 根据当前文本决定下一个文本
        switch (prevText) {
          case 'AI 正在思考，请稍等':
            return 'AI 正在思考，请稍等.';
          case 'AI 正在思考，请稍等.':
            return 'AI 正在思考，请稍等..';
          case 'AI 正在思考，请稍等..':
            return 'AI 正在思考，请稍等...';
          case 'AI 正在思考，请稍等...':
          default:
            return 'AI 正在思考，请稍等';
        }
      });
    }, 500);
    
    // 清除定时器，防止在组件卸载时内存泄漏
    return () => clearInterval(dotsIntervalRef.current);
  }, [messages]);

  const hasCalled = useRef(false); // 标记是否已调用
  // 处理一次性调用的 useEffect
  useEffect(() => {
    // 一次性调用逻辑
    console.log('This runs only once when the component mounts');
    if(!hasCalled.current){
      hasCalled.current = true;
      getFingerprint2();

      const queryParams = new URLSearchParams(window.location.search);
      const param = queryParams.get("param");
      const productType = queryParams.get("productType");
      console.log("param: " + param)
      console.log("productType: " + productType)
      if(param !=='' && param !==null && sendMessageRef.current){
        sendMessageRef.current.ParentHandleSendMessage(param, productType);
      }
    }
    
  }, []); // 空数组表示只在组件挂载时运行一次

  useEffect(() => {
    // 等待下一次事件循环，以确保DOM已经更新
    setTimeout(() => {
      if (chatHistoryRef.current) {
        // 将页面滚动到聊天窗口底部
        window.scrollTo({
          top: chatHistoryRef.current.offsetTop + chatHistoryRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 0);
  }, [messages, messagesHistroy]); // 依赖数组messages和messagesHistroy
  

  return (
    <div className="container" ref={chatMainRef}>
      
      <CallAndEmail></CallAndEmail>
     
      <div className="chat-container" ref={chatHistoryRef}>

        <div className="chat-history-history">
         
        {
          messagesHistroy.length +  messages.length <= 2 &&
          (<div>
             <ChatMessageWelcome />
          </div>)
        }

          {messagesHistroy.length === 0 &&  messages.length === 0 &&
            <div>
              <TopMessageControl onClick={onButtonClick}></TopMessageControl>
            </div>
          }

          {messagesHistroy.slice().reverse().reduce((acc, msg, index) => {
            const prevMsg = acc.length > 0 ? acc[acc.length - 1].props.message.createdAt : null;
            
            acc.push(
              <ChatMessageHistroy
                key={index}
                message={msg}
                prevUpdatedAt={prevMsg}
              />
            );
            return acc;
          }, [])}
        </div>

        <div className="chat-history" >
          {messages.map((msg, index) => (
            <ChatMessage key={index} message={msg.text} isUser={msg.isUser} isError={msg.isError} answers={msg.answer}/>
          ))}
        </div>
        {isGenerating && (
          <div className="generating-status">
            {loadingText}
          </div>
        )}

        {
          messagesHistroy.length +  messages.length <= 2 &&
          (<div>
            <div className="footer-placeholder"></div>
            <div className="footer-placeholder"></div>
          </div>)
        }

         {
          messagesHistroy.length +  messages.length > 0 &&
          (<div className='tips'>
            <div className='tips'>
              由昂听AI生成，内容仅供参考
            </div>
          </div>)
        }
      </div>
      <div className="footer-placeholder"></div>
      <div className="input-container">
          <ChatInput ref={sendMessageRef} onSendMessage={handleSendMessage} />
      </div>
      
    </div>
  );
};



function App() {
  return (
    <div className="App">
      <header className="App-header">
        <ChatUI></ChatUI>
      </header>
    </div>
  );
}

export default App;
